export default __webpack_public_path__ + "static/media/2.f66d3426.png";